<template>
  <div class="top">
    <div class="index">
      <div class="logo">
        <img src="@/assets/png/logo.png" style="" alt="" />
      </div>
      <div class="nav-box" v-if="screenWidth >= 768">
        <span
          v-for="(item, index) in nav"
          :key="index"
          :class="selIndex == index ? 'active' : ''"
          @click="navClick(item.path, index)"
        >
          {{ item.name }}
        </span>
      </div>

      <div class="dropdown" v-else>
        <!-- <select @change="dropdownChange($event.target.value)">
          <option v-for="item in nav" :key="item.name" :value="item.path">
            {{ item.name }}
          </option>
        </select> -->
        <el-select @change="dropdownChange" v-model="chooseName">
          <el-option
            v-for="item in nav"
            :key="item.path"
            :label="item.name"
            :value="item.path"
          />
        </el-select>
      </div>
      <div class="contact">
        <img src="@/assets/png/tel.png" />
        <span>0574-83083863</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      screenWidth: window.innerWidth,
      selIndex: "",
      nav: [
        {
          name: "首页",
          path: "/home",
        },
        // {
        //   name: "关于我们",
        //   path: "/about",
        // },
        {
          name: "公司简介",
          path: "/intro",
        },
        {
          name: "产品中心",
          path: "/product",
        },

        {
          name: "联系我们",
          path: "/contact",
        },
        // {
        //   name: "公司简介",
        //   path: "/intro",
        // },
        {},
      ],
      chooseName: "",
    };
  },

  created() {
    window.addEventListener("resize", this.updateScreenWidth);
    let temp = window.location.href.split("#")[1];
    this.chooseName = temp;
    for (let i = 0; i < this.nav.length; i++) {
      if (temp == this.nav[i].path) {
        this.selIndex = i;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      localStorage.setItem("screenWidth", this.screenWidth);
    },
    isChecked(item) {
      return !item.path.indexOf(this.$route.path);
    },
    navClick(path, index) {
      this.selIndex = index;
      this.$router.push(path);
    },
    dropdownChange(path) {
      this.$router.push(path);
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.top {
  display: flex;
  justify-content: center;
  background-color: #fafafa;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .index {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 100px;
    padding-right: 100px;
    width: 95%;
    margin: 0 auto;
    /* height: 112px; */
    height: 130px;
  }
  .logo {
    width: 250px;
    display: flex;
    /* height: 100px; */
    align-items: center;
  }
  .logo img {
    /* height: 60px; */
    width: 100%;
    object-fit: cover;
    margin-right: 10px;
  }
  .nav-box {
    margin-left: -77px;
    width: 800px;
    display: flex;
    font-size: 20px;
    justify-content: space-evenly;
  }

  .nav-box span {
    /*不同浏览器的渐变效果*/
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  .nav-box :hover {
    color: #3a8ee6;
    cursor: pointer;
  }
  .contact {
    display: flex;
    align-items: center;
    font-size: 20px;
    img {
      width: 30px;
    }
    span {
      color: #0598e6;
      font-weight: bold;
      margin-left: 10px;
    }
  }
  .active {
    color: #3a8ee6;
  }
}

/* 媒体查询：在屏幕宽度小于768px时应用不同的样式 */
@media screen and (max-width: 768px) {
  .index {
    width: 100%;
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: flex-start;
    padding-left: 5px;
    padding-right: 5px;
  }
  .logo {
    width: 100px;
    margin-left: 10px;
    margin-right: 30px;
  }
  .logo img {
    /* height:100%; */
    width: 100px;
  }
  .nav-box {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .nav-box span {
    margin-bottom: 10px;
  }
  .contact {
    display: flex;
    align-items: center;
    font-size: 11px;
    margin-left: 20px;
    img {
      width: 20px;
      margin-right: 3px;
    }
    span {
      color: #0598e6;
      font-weight: bold;
    }
  }
}
/* 添加样式到下拉菜单 */
select {
  /* 设置下拉菜单的字体样式和大小 */
  font-family: Arial, sans-serif;
  font-size: 16px;

  /* 设置下拉菜单的边框样式 */
  border: 1px solid #ccc;
  border-radius: 4px;

  /* 设置下拉菜单的背景颜色和文字颜色 */
  background-color: #fff;
  color: #333;

  /* 设置下拉菜单的大小 */
  /* width: 200px; */
  padding: 8px;
}

/* 设置选中项的样式 */
option:checked {
  background-color: #3a8ee6; /* 设置选中项的背景颜色 */
  color: #fff; /* 设置选中项的文字颜色 */
}

/* 鼠标悬停时的样式 */
option:hover {
  background-color: #f0f0f0; /* 设置鼠标悬停时的背景颜色 */
}
</style>
